import { 
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './features/auth/contexts/AuthContext';
import { ThemeProvider } from './features/theme/contexts/ThemeContext';
import { TourProvider } from './features/tour/contexts/TourContext';
import Layout from './components/Layout/Layout';
import HomePage from './pages/Home/HomePage';
import LoginPage from './pages/Auth/LoginPage';
import RegisterPage from './pages/Auth/RegisterPage';
import ResetPasswordPage from './pages/Auth/ResetPasswordPage';
import LearnPage from './pages/Learn/LearnPage';
import TutorialPage from './pages/Learn/TutorialPage';
import CommunityPage from './pages/Community/CommunityPage';
import ChallengesPage from './pages/Challenges/ChallengesPage';
import RankingPage from './pages/Ranking/RankingPage';
import ProfilePage from './pages/Profile/ProfilePage';
import ProtectedRoute from './features/auth/components/ProtectedRoute';
import SubscribePage from './pages/Subscribe/SubscribePage';
import SubscribeSuccess from './pages/Subscribe/SubscribeSuccess';
import UpdatePasswordPage from './pages/Auth/UpdatePasswordPage';
import CriteriaPage from './pages/Criteria/CriteriaPage';
import BadgePage from './pages/Badges/[badgeId]';
import './styles/cyberpunk.css';
import PWAInstallPrompt from './components/PWAInstallPrompt';



const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />
      },
      {
        path: "login",
        element: <LoginPage />
      },
      {
        path: "register",
        element: <RegisterPage />
      },
      {
        path: "reset-password",
        element: <ResetPasswordPage />
      },
      {
        path: "update-password",
        element: <UpdatePasswordPage />
      },
      {
        path: "community",
        element: <CommunityPage />
      },
      {
        path: "learn",
        element: <ProtectedRoute><LearnPage /></ProtectedRoute>
      },
      {
        path: "learn/:learningPathSlug/:courseSlug/:tutorialSlug?",
        element: <ProtectedRoute><TutorialPage /></ProtectedRoute>
      },
      {
        path: "challenges",
        element: <ProtectedRoute><ChallengesPage /></ProtectedRoute>
      },
      {
        path: "profile",
        element: <ProtectedRoute><ProfilePage /></ProtectedRoute>
      },
      {
        path: "ranking",
        element: <ProtectedRoute><RankingPage /></ProtectedRoute>
      },
      {
        path: "criteria/:badgeId",
        element: <CriteriaPage />
      },
      {
        path: "badges/:badgeId",
        element: <BadgePage />
      },
      {
        path: "?code=:code",
        element: <LoginPage />
      }
    ]
  },
  {
    path: "/subscribe",
    element: <ProtectedRoute><SubscribePage /></ProtectedRoute>,
  },
  {
    path: "/subscribe/success",
    element: <ProtectedRoute><SubscribeSuccess /></ProtectedRoute>,
  }
]);

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <TourProvider>
            <RouterProvider router={router} />
            <Toaster position="top-right" />
            <PWAInstallPrompt />
          </TourProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
